export const EVENTS = {
  ADMIN_LOGIN: 'admin:session:start',
  ADMIN_PASSWORD_SET: 'admin:password:set',
  ADMIN_SETUP_COMPLETE: 'admin:setup:complete',
  APP_INITIALIZED: 'app:initialized',
  APP_USER: 'app:user',
  USER_CREATED: 'user:created',
  SESSION_START: 'session:start',
  SESSION_END: 'session:end',
  USER_EMAIL_VERIFIED: 'user:email:verified',
  USER_PHONE_VERIFIED: 'user:phone:verified',
  USER_PHONE_ADDED: 'user:phone:added',
  UPDATE_BANK_CARD: 'update:bank:card',
  UPDATE_USER: 'update:user',
  UPDATE_BUSINESS: 'update:business',
  PROPERTY_LISTING: 'set:property:listing',
  PAGEVIEW: 'pageview',
  CHECKOUT: 'checkout',
  PURCHASE: 'purchase',
  FAILED_PURCHASE: 'failedpurchase',
  ADD_CARD_PAYMENT: 'add:card:payment',
  CONTACT: 'contact',
  SEARCH_PROPERTY: 'search',
  DELETE_PROPERTY: 'delete',
  CREATE_PROPERTY: 'create',
  PUBLISH_PROPERTY: 'publish',
  UNPUBLISH_PROPERTY: 'unpublish',
  SEND_MESSAGE: 'message',
  INITIATE_REQUEST_BOOKING: 'initiaterequestbooking',
  REQUEST_BOOKING: 'requestbooking',
  VIEW_PROPERTY: 'viewproperty',
  VIEW_PAYMENTS: 'payments',
  VIEW_SETTINGS: 'settings',
  EDIT_USER_PASSWORD: 'editpassword',
  SOCIAL_SHARE: 'share',
  CTA_CLICKS: 'cta',
  CLICK_BLOG_POST: 'blogpost',
  CLICK_LOCATIONS: 'location',
  CLICK_FOOTER_LINKS: 'footer',
  CLICK_LISTING_CAROUSELS: 'carousel',
  NO_PROPERTY_FOUND: 'noproperty',
  INSTALL_PWA: 'new-pwa-installation',
  LAUNCH_PWA: 'open-pwa',
  CUSTOMER_ENQUIRY: 'customer-enquiry',
  ASSISTED_BOOKINGS: 'assisted-booking',
  EXPENSE_UPLOAD: 'expense-upload'
};
